import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid2';
import LoyaltyRoundedIcon from '@mui/icons-material/LoyaltyRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import { useLanguage } from '../contexts/LanguageContext';

export default function Features() {
  const { translations } = useLanguage();

  const items = [
    {
      icon: <LoyaltyRoundedIcon />,
      title: translations.features_section.customer_title,
      description: translations.features_section.customer_description,
    },
    {
      icon: <StorefrontRoundedIcon />,
      title: translations.features_section.owner_title,
      description: translations.features_section.owner_description,
    },
    {
      icon: <BoltRoundedIcon />,
      title: translations.features_section.operations_title,
      description: translations.features_section.operations_description,
    },
  ];

  return (
    <Container id="features" sx={{ py: { xs: 8, sm: 14 } }}>
      <Stack spacing={2.5} sx={{ mb: 6, maxWidth: 760 }}>
        <Chip label={translations.features} color="primary" variant="outlined" sx={{ alignSelf: 'flex-start' }} />
        <Typography component="h2" variant="h3" sx={{ color: 'text.primary' }}>
          {translations.features_section.title}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, maxWidth: 620 }}>
          {translations.features_section.description}
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        {items.map((item, index) => (
          <Grid size={{ xs: 12, md: 4 }} key={item.title}>
            <Card
              variant="outlined"
              sx={{
                height: '100%',
                p: 3.5,
                borderRadius: 5,
                background:
                  index === 1
                    ? 'linear-gradient(180deg, rgba(124, 58, 237, 0.12), rgba(255,255,255,0.96))'
                    : 'linear-gradient(180deg, rgba(255,255,255,0.96), rgba(248,247,255,0.96))',
              }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  p: 1.5,
                  borderRadius: 3,
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  mb: 2.5,
                }}
              >
                {item.icon}
              </Box>
              <Typography variant="h5" sx={{ mb: 1.5 }}>
                {item.title}
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                {item.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
